module.exports = __webpack_public_path__ + "img/templa_a.55c55b86.png";